module.exports = __webpack_public_path__ + "img/solid-lamp-street-circle-bolt.88fa02f2.png";